import React from "react";
import Navigation from "../components/Navigation";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import SubscribeForm from "../components/SubscribeForm";
import "../style/global";

export default ({ children, location }) => (
  <main>
    <Navigation location={location} />
    {children()}
    {/* <SubscribeForm />*/}
    <Menu />
  </main>
);



// WEBPACK FOOTER //
// ./src/layouts/index.js